// Конфигурация Firebase
// Этот файл содержит настройки для Firebase Cloud Messaging
// Все значения должны быть установлены в .env файле

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

// VAPID ключ для Web Push API
export const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

// Проверка конфигурации
export const isFirebaseConfigured = () => {
  return !!(firebaseConfig.apiKey && 
            firebaseConfig.projectId && 
            firebaseConfig.messagingSenderId);
};

// Получение информации о конфигурации
export const getFirebaseConfigInfo = () => {
  return {
    isConfigured: isFirebaseConfigured(),
    hasApiKey: !!firebaseConfig.apiKey,
    hasProjectId: !!firebaseConfig.projectId,
    hasMessagingSenderId: !!firebaseConfig.messagingSenderId,
    hasMeasurementId: !!firebaseConfig.measurementId,
    hasVapidKey: !!vapidKey,
    projectId: firebaseConfig.projectId || 'not-set'
  };
};



